import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import'./AmanagerDashbord.css'
import api from "../services/api";

// You can remove ChartJS registration if no charts are being used in this file.
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

// API URL for the manager's assigned forms
const API_MANAGER_FORMS_URL = api.defaults.baseURL + "/manager/assigned-forms";


const Asubmission = () => {
    const [forms, setForms] = useState([]);
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(null);
        const [searchQuery, setSearchQuery] = useState(''); // State for the search query
    
        // Get manager's name from localStorage
        const managerName = useMemo(() => {
            try {
                return JSON.parse(localStorage.getItem('user'))?.name || 'Manager';
            } catch {
                return 'Manager';
            }
        }, []);
    
        // Fetch all forms assigned by this manager
        useEffect(() => {
            const fetchManagerForms = async () => {
                setIsLoading(true);
                setError(null);
                const token = localStorage.getItem('authToken');
                if (!token) {
                    setError("Authentication Error: Please log in again.");
                    setIsLoading(false);
                    return;
                }
    
                try {
                    const response = await fetch(API_MANAGER_FORMS_URL, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    });
                    if (!response.ok) throw new Error(`Server Error: ${response.status}`);
                    const data = await response.json();
                    setForms(data);
                } catch (e) {
                    setError(e.message);
                } finally {
                    setIsLoading(false);
                }
            };
            fetchManagerForms();
        }, []);
    
        // Memoized filtered forms based on search query
        const filteredForms = useMemo(() => {
            if (!searchQuery) return forms;
    
            const lowercasedQuery = searchQuery.toLowerCase();
    
            return forms.filter(form => {
                const brokerName = (form.brokerUserId?.name || '').toLowerCase();
                const invoiceId = (form.baseInvoiceId || '').toLowerCase();
                const submissionDate = new Date(form.createdAt).toLocaleDateString().toLowerCase();
    
                return (
                    brokerName.includes(lowercasedQuery) ||
                    invoiceId.includes(lowercasedQuery) ||
                    submissionDate.includes(lowercasedQuery)
                );
            });
        }, [forms, searchQuery]);
    
    
        if (isLoading) return <div className="manager-dashboard-pages"><div className="card"><h2>Loading Submission forms...</h2></div></div>;
        if (error) return <div className="manager-dashboard-pages"><div className="card error-card"><h2>Error</h2><p>{error}</p></div></div>;
    
  return (
    <div className="manager-dashboard-pages">
                <header className="dashboard-header">
                    <h1>Assigned Forms</h1>
                    <p>Welcome back, {managerName}! Here's the latest activity from your team.</p>
                </header>
    
                <main className="dashboard-layout" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div className="dashboard-main-content">
                        <div className="card">
                            <div className="card-header" style={{backgroundColor: '#f8f9fa', padding: '10px', borderRadius: '5px' }}>
                                <h3 className="card-title">All Assigned Forms</h3>
                                {/* Search Bar */}
                                <div className="search-bar-container"style={{ marginBottom: '20px',backgroundColor: '#f8f9fa', padding: '10px', borderRadius: '5px' }}>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search by invoice, name, or submission date..."
                                        value={searchQuery}
                                        onChange={e => setSearchQuery(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>Broker</th>
                                            <th>Status</th>
                                            <th>Invoice #</th>
                                            <th>Assigned On</th>
                                            <th>Submission Date</th> {/* New Column Header */}
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredForms.length > 0 ? (
                                            filteredForms.map(form => (
                                                <tr key={form._id}>
                                                    <td>{form.brokerUserId?.name || 'N/A'}</td>
                                                    <td><span className={`badge status-${form.status}`}>{form.status}</span></td>
                                                    <td>{form.baseInvoiceId || '---'}</td>
                                                    <td>{new Date(form.createdAt).toLocaleDateString()}</td>
                                                    {/* New Column Data */}
                                                    <td>{new Date(form.createdAt).toLocaleDateString()}</td>
                                                    <td>
                                                        <Link to={`/Manager/form/${form._id}`} className="btn btn-sm btn-outline-primary">View / Edit</Link>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="text-center">No matching forms found.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
  );
}

export default Asubmission